import { LoadingButton } from '@mui/lab';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';

function CreateDialog(props) {
    const { open, title, subTitle, onClose, onSubmit, waiting, onValidate } = props;

    const theme = useTheme();

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [error, setError] = useState(null);

    const handleValidate = async () => {

        try {
            const isDuplicate = await onValidate(name);
            if (isDuplicate) { // ตรวจสอบว่าไม่มีชื่อซ้ำในระบบ
                setError("The name already exists in the system.")
            } else {
                setError(null);
            }
        } catch (error) {
            setError(error.message)
        }
    };

    const hasSpecialCharacters = (str) => /[^\p{L}\p{N}\s.-]/u.test(str);

    const handleOnSubmit = () => {
        onSubmit(name, description);
        if (!waiting) {
            handleOnClose();
        }
    };

    const handleOnClose = () => {
        setName("");
        setDescription("");
        setError(null);
        onClose();
    }

    return (
        <Dialog
            fullWidth={false}
            maxWidth={"xs"}
            open={open}
        >
            <DialogTitle
                sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.white.main, paddingY: 1, paddingX: 2 }}
                className='flex justify-between items-center'
            >
                <Typography>{title}</Typography>
                {onClose &&
                    <IconButton
                        aria-label="close"
                        onClick={handleOnClose}
                        sx={{
                            padding: 0,
                            color: theme.palette.white.main
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            </DialogTitle>
            <DialogContent dividers>
                {subTitle && <Typography variant='subtitle2'>{subTitle}</Typography>}
                <Box
                    component="form"
                    autoComplete="off"
                >
                    <TextField
                        required
                        size='small'
                        id="name"
                        label="Policy Name"
                        fullWidth
                        margin="normal"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value)
                            // ตรวจสอบว่าไม่มีการใส่ชื่อ
                            if (!e.target.value) {
                                setError("The name field cannot be empty.")
                            }
                            // ตรวจสอบว่าไม่มีช่องว่าง
                            else if (/\s/.test(e.target.value)) {
                                setError("The name should not contain spaces.")
                            }
                            // ตรวจสอบว่ามีเฉพาะตัวอักษรภาษาอังกฤษ ตัวเลข และเครื่องหมาย `_` หรือ `-`
                            else if (hasSpecialCharacters(e.target.value)) {
                                setError("Special characters are not allowed")
                            } else {
                                setError(null)
                            }
                        }}
                        onBlur={handleValidate}
                        error={!!error}
                        helperText={error || ""}
                    />
                    <TextField
                        id="description"
                        label="Description"
                        fullWidth
                        multiline
                        rows={3}
                        margin="normal"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <LoadingButton variant="contained" disabled={!!error} loading={waiting} onClick={handleOnSubmit}>Create</LoadingButton>
            </DialogActions>
        </Dialog>
    )
}

export default CreateDialog